import React from 'react'

interface ITargetProps {
  deselectAnnotation: () => void
}

interface IProps {
  targetProps?: ITargetProps
  TargetComponent?: React.FC<ITargetProps>
}

const NoDeselectAnnotationsOverlay: React.FC<IProps> = ({
  targetProps,
  TargetComponent,
}) => {
  if (targetProps === undefined || TargetComponent === undefined) {
    return <div />
  }

  return (
    <TargetComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...targetProps}
      deselectAnnotation={newDeselectAnnotation}
    />
  )
}

// Disable deselection annotations from the canvas
// eslint-disable-next-line @typescript-eslint/no-empty-function
const newDeselectAnnotation = (): void => {}

const exportedObject = {
  name: 'NoDeselectAnnotationsOverlay',
  target: 'AnnotationsOverlay',
  mode: 'wrap',
  component: NoDeselectAnnotationsOverlay,
}
export default exportedObject
